var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isViewPhotoModalShowing)?_c('div',{staticClass:"modal-viewer",class:{
    active: _vm.isViewPhotoModalShowing,
    hidden: !_vm.isViewPhotoModalShowing,
  },attrs:{"id":"hey"},on:{"click":function($event){return _vm.cancel()}}},[_c('div',{staticClass:"ui container modal-viewer-container"},[_c('div',{staticClass:"ui image image-preview"},[_c('img',{attrs:{"src":_vm.imageSrc}})]),_c('p',{staticStyle:{"margin-top":"10px","color":"white","text-align":"center"},on:{"click":_vm.cancel}},[_vm._v(" Tippen, um die Vorschau zu schließen. ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }